import { render, staticRenderFns } from "./AlbumItems.vue?vue&type=template&id=ac178dc0&scoped=true"
import script from "./AlbumItems.vue?vue&type=script&lang=js"
export * from "./AlbumItems.vue?vue&type=script&lang=js"
import style0 from "./AlbumItems.vue?vue&type=style&index=0&id=ac178dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac178dc0",
  null
  
)

export default component.exports